import { LoadingButton } from '@mui/lab';
import { Box } from '@mui/material';
import { useNotification } from '@revenuewell/front-end-bundle';
import { FC, useEffect, useState } from 'react';
import { useInsuranceApi } from '../../../../../hooks/use-insurance-api';
import { ProviderSelectionDialog } from '../../../shared/components/provider-selection-dialog/provider-selection-dialog';
import { usePatientIvStatusDialog } from '../../hooks/use-patient-iv-status-dialog/hook';

export interface IButtonProps {
  onSuccess: () => Promise<void>;
  disabled?: boolean;
}

export const ManuallyVerifiedButton: FC<IButtonProps> = (props) => {
  const { onSuccess, disabled } = props;
  const { showError, showSuccess } = useNotification();
  const { status, manualVerification } = useInsuranceApi();
  const {
    locationId,
    providerId,
    patientFlow,
    sendIvStatusUpdatedEvent,
    setIsLoading,
    verificationPriority,
    providers
  } = usePatientIvStatusDialog();
  const [providerDialogOpen, setProviderDialogOpen] = useState(false);

  useEffect(() => {
    if (status.manualVerification.error) showError('Unable to perform the operation.');
  }, [status.manualVerification.error]);

  const updateInsuranceStatus = async () => {
    providerId ? await manuallyVerifiedRequest(providerId) : setProviderDialogOpen(true);
  };

  const manuallyVerifiedRequest = async (providerId: number) => {
    setIsLoading(true);

    const success = await manualVerification(locationId, patientFlow.patientId, providerId, verificationPriority);

    if (success) {
      showSuccess('Status was updated successfully.');
      sendIvStatusUpdatedEvent();
      await onSuccess();
    }

    setIsLoading(false);
  };

  const handleProviderDialogSubmit = async (selectedProviderId: number) => {
    await manuallyVerifiedRequest(selectedProviderId);
    setProviderDialogOpen(false);
  };

  const handleProviderDialogClose = () => {
    setProviderDialogOpen(false);
  };

  return (
    <Box>
      <LoadingButton
        disableElevation
        variant="outlined"
        color="primary"
        onClick={updateInsuranceStatus}
        loading={status.manualVerification.isRunning}
        disabled={disabled}
      >
        Manually Verified
      </LoadingButton>
      <ProviderSelectionDialog
        open={providerDialogOpen}
        title="Manually Verified - Choose Provider"
        providers={providers}
        onClose={handleProviderDialogClose}
        onSubmit={handleProviderDialogSubmit}
      />
    </Box>
  );
};
